/** Builder section types of the `bikini` templates. No imports: `entities/LandingPage` reads it. */
export const bikiniSectionTypes = [
  "bikiniHero",
  "bikiniBoxes",
  "bikiniVideo",
  "bikiniMetamorphoses",
  "bikiniStatNumbers",
  "bikiniWays",
  "bikiniIncluded",
  "bikiniHowItWorks",
  "bikiniPriceBanner",
  "bikiniFeatures",
  "bikiniNonForbiddenProducts",
  "bikiniRecommendations",
  "bikiniMoneyBack",
  "bikiniFaq",
  "bikiniFooter",
  "bikiniStickyBar",
] as const;
